import type * as React from 'react';
import { SectionTitle as Title, Text } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * SectionItemのProps
 */
interface SectionItemProps {
  /** ラベル */
  label: React.ReactNode;
  /** ボディ */
  children: React.ReactNode;
}

/** セクション内項目 */
export const SectionItem = ({ label, children }: SectionItemProps) => {
  return (
    <div className={styles['jobSearchDetail-sectionItem']}>
      <Title
        bgType="none"
        size="M"
        as="h3"
        className={styles['jobSearchDetail-sectionItem__label']}
      >
        {label}
      </Title>
      <div className={styles['jobSearchDetail-sectionItem__content']}>
        <Text color="black_pc" size="14--articlePC" weight="normal" as="div">
          {children}
        </Text>
      </div>
    </div>
  );
};
